<template>

  <button v-if="'xm' in $attrs" small outlined v-bind="$attrs" v-on="$listeners"
    class="imd-xm-btn xs"
    :class="{
      'white': 'white' in $attrs
    }">
    <slot></slot>
  </button>

  <!-- 테이블 내에 쓰는 버튼타입 -->
  <button v-else-if="'btn01' in $attrs" small outlined class="imd-sm-btn01" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </button>
  <button v-else-if="'btn02' in $attrs" small outlined class="imd-sm-btn02" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </button>
  <button v-else-if="'btn03' in $attrs" small outlined class="imd-sm-btn03" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </button>
  <button v-else-if="'btn04' in $attrs" small outlined class="imd-sm-btn04" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </button>

  <button v-else small class="imd-sm-btn xs" outlined v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </button>

</template>

<style>
/* 아주 작은 버튼 */
.imd-xm-btn.button.xs.button.button--depressed.button--flat.button--outlined.theme--light.v-size--small
{ padding: 0 2px; min-width: 10px; height: 18px; line-height: 18px; vertical-align: middle; }
.imd-xm-btn.button.button--outlined { border-color: #b1b1b1 !important;  }
.imd-xm-btn.button.button--outlined.white { background-color: white !important; }
.imd-xm-btn .button__content { color: black; font-size: 12px; line-height: 12px; }
.imd-xm-btn { margin:0 2px; height:22px; min-width:50px; height:23px; border-radius: 3px;}

/* 일반 버튼 */
.imd-sm-btn.button.button.button--depressed.button--flat.button--outlined.v-size--small
 {padding: 0px 2px 0 2px; min-width: 10px; height: 21px; line-height: 20px; vertical-align: middle; margin: -2px 0 0 0; letter-spacing: 0; }
/* wrap */
.imd-sm-btn.button.button--outlined { border-color: #b1b1b1 !important; background-color: white !important; }
/* 버튼 안에 글자 */
.imd-sm-btn .button__content { color: black; font-size: 12px; line-height: 12px; padding: 0 3px;  }

/* 테이블 버튼 */
.imd-sm-btn .button__content { color: black; font-size: 12px; line-height: 12px; padding: 0 3px;  }

/* btn01 블루 out*/
button.imd-sm-btn01.button.button--depressed.button--flat.button--outlined.theme--light.v-size--small
{padding: 0px 4px 0 4px; min-width: 10px; height: 28px; line-height: 20px; vertical-align: middle; margin: -2px 0 0 0;}
button.imd-sm-btn01.button.button--outlined { border-color: #1976d2 !important; background-color: white !important; color:#1976d2; font-size:12px;}

/* btn02 오렌지 out*/
button.imd-sm-btn02.button.button--depressed.button--flat.button--outlined.theme--light.v-size--small
{padding: 0px 4px 0 4px; min-width: 10px; height: 28px; line-height: 20px; vertical-align: middle; margin: -2px 0 0 0;}
button.imd-sm-btn02.button.button--outlined { border-color: #ff6600 !important; background-color: white !important; color:#ff6600; font-size:12px;}

/* btn03 븕은 out*/
button.imd-sm-btn03.button.button--depressed.button--flat.button--outlined.theme--light.v-size--small
{padding: 0px 4px 0 4px; min-width: 10px; height: 28px; line-height: 20px; vertical-align: middle; margin: -2px 0 0 0;}
button.imd-sm-btn03.button.button--outlined { border-color: #da281f !important; background-color: white !important; color:#da281f; font-size:12px;}

/* btn04 회색 out*/
button.imd-sm-btn04.button.button--depressed.button--flat.button--outlined.theme--light.v-size--small
{padding: 0px 4px 0 4px; min-width: 10px; height: 28px; line-height: 20px; vertical-align: middle; margin: -2px 0 0 0;}
button.imd-sm-btn04.button.button--outlined { border-color: #666666 !important; background-color: white !important; color:#666666; font-size:12px;}


</style>

<script>
  export default {
    inheritAttrs: false,
    created() {
    //  console.log("xm = ", Math.random(), this.xm, (this.xm !== undefined) );
    },
  }
</script>